import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_LARGE } from '~/constants';

import { zodContractItemSchema } from '../validations';

import { CONTRACT_ITEM_SORT_FIELDS } from './constants';

/**
 * Validation schemas for contract items list API calls.
 */

export const zodContractItemsQueryParamsSchema = z.object({
  // true lists only active items, false only inactive ones, omitted lists both.
  active: z.boolean().optional(),
  invalidItemsOnly: z.boolean().optional(),
  limit: z.number().int().min(1).max(500).default(PAGINATION_PAGE_SIZE_LARGE),
  offset: z.number().int().min(0).default(0),
  // Omitted, the API sorts by position. Items without a value come last in both directions.
  orderBy: z.enum(CONTRACT_ITEM_SORT_FIELDS).optional(),
  searchString: z.string().trim().nullish(),
  // Lower case like the grid's sort direction; the fetcher sends it upper case.
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export const zodContractItemsResponseSchema = z.object({
  data: z.array(zodContractItemSchema),
  hasNextPage: z.boolean(),
  // Incomplete items of the whole contract, regardless of search and filter.
  invalidItemsTotalCount: z.number().int().nonnegative().nullish(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
  totalPrice: z.string().trim().nullish(), // Decimal API string. Sum over all items of the (filtered) response.
});
